<template>
    <div class="demand-item card">
        <div class="demand-title" @click="visit">
            <div class="demand-title__layouts">
                {{demand.city}}<span v-if="demand.layout_label">-{{demand.layout_label}}</span>
            </div>
            <div class="demand-title__budget">
                {{demand.cost_label}}
            </div>
        </div>
        <div class="demand-content" v-if="demand.content" @click="visit">
            <div class="demand-content__description">
                <div>{{demand.content}}</div>
            </div>
        </div>
        <div class="demand-time">
            {{demand.format_create_time}}
            <span v-if="demand.status != 0">已撤单</span>
        </div>
        <div class="demand-receive" @click="order" v-if="!demand.has_receive">接 单</div>
        <div class="demand-opt" v-else>
            <div v-if="!demand.has_receive" style="flex: 1"></div>
            <div class="demand-btns">
                <img
                src="@/assets/icons/comments-sharp-light.svg"
                class="demand-btns__icon" v-if="demand.has_receive && demand.has_contact"
                @click="contact"/>
                <img
                src="@/assets/icons/message-lines-sharp-light.svg"
                class="demand-btns__icon"
                v-if="demand.has_receive"
                @click="send"/>
            </div>
            <!-- <div class="demand-btns" v-if="detail && demand.has_contact">
                <img
                src="@/assets/icons/circle-question-sharp-light.svg"
                class="demand-btns__icon" v-if="demand.has_receive"
                @click="feedback"/>
            </div> -->
        </div>
    </div>
</template>

<script>
    const weui = window.weui
    import { viewReceive, receiveDemand, contactDemand } from "@/interface/modules/requirement.api"
    import token from '@/interface/utils/token'

    export default {
        props: ['demand', 'detail'],
        computed: {
            tags: function () {
                const that = this
                if (this.demand) {
                    return this.demand.layout.split(',').map(item => that.layouts[item])
                } else {
                    return []
                }
            }
        },
        methods: {
            visit () {
                this.$router.push({name: 'requirementDetail', params: {id: this.demand.id}})
            },
            send () {
                token.setValue('dialog', this.demand.message_info)
                this.$router.push({name: 'messageReply'})
            },
            order () {
                const that = this
                viewReceive({
                    data: this.demand.id,
                    success: res => {
                        const cost = res.cost_bonus
                        const toast = weui.confirm(`此操作消耗${cost}积分`, ()=> {
                            toast.hide(() => that.receive())
                        }, () => {return}, {
                            title: '接单需求'
                        })
                    }
                })
            },
            receive () {
                const that = this
                receiveDemand({
                    data: that.demand.id,
                    success: () => {
                        that.$emit("receive")
                    },
                    fail: err => {
                        if (err == 23401) {
                            weui.alert('积分不足，无法接单', {title: '积分不足'})
                        }
                    }
                })
            },
            contact () {
                contactDemand({
                    data: this.demand.id,
                    success: res => {
                        weui.confirm(res, {
                            title: "微信号",
                            buttons: [
                                {
                                    label: '取消',
                                    type: 'default'
                                },
                                {
                                    label: '点击复制',
                                    type: 'primary',
                                    onClick: function () {
                                        navigator.clipboard.writeText(res).then(() => {
                                            weui.toast('复制成功', 3000)
                                        })
                                    }
                                }
                            ]
                        })
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .demand-time {
        font-size: 9pt;
        color: #999;
        margin-top: 5px;
    }

    .demand-title {
        display: flex;
        align-items: center;
        font-weight: 450;
        justify-content: space-between;
        .demand-title__budget {
            margin-right: 10px;
            color: #08979C;
            padding-left: 10px;
        }
        .demand-title__item {
            min-width: 0;
            .demand-title__item_name {
                font-size: 9pt;
                color: #999;
            }
            .demand-title__item_value {
                font-size: 13pt;
                width: 100%;
            }
        }
    }
    .demand-content {
        margin-top: 5px;
        .demand-content__description {
            font-size: 11pt;
            color: #333;
        }
    }

    .demand-content__contact {
        display: flex;
        align-items: center;
        .demand-content__contact_icon {
            width: 14px;
            height: 14px;
            margin-right: 5px;
        }
        .demand-content__contact_name {
            font-size: 10pt;
            color: #333;
        }
    }

    .demand-item {
        margin-top: 10px;
        padding: 10px 15px;
        .demand-table__row {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 10px 0;
            font-size: 11pt;
            .demand-table__row_name {
                color: #666;
            }
            .demand-table__row_value {
                color: #333;
                width: 100%;
            }
        }
        .demand-opt {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 15px;
            height: 37px;
            border-top: 1px solid #eee;
            padding-top: 10px;
            .demand-btns {
                display: flex;
                align-items: center;
                .demand-btns__item {
                    font-size: 10pt;
                    margin-left: 10px;
                    padding: 2px 8px;
                    color: #08979C;
                }
                .demand-btns__icon {
                    width: 20px;
                    height: 18px;
                    padding: 0 10px;
                }
            }
        }
    }

    .demand-receive {
        padding: 8px 0;
        margin-top: 15px;
        background-color: #f3f4f5;
        border-radius: 4px;
        text-align: center;
        color: #333;
        font-size: 10pt;
    }
</style>


